import { createSelector } from "reselect";
import AppConfig from '../../AppConfig';
const {
  BOOK_TYPES: {
    AUDIO,
    AUDIO_BOOK
  }
} = AppConfig;

export const getVideoPlayerState = ({ videoPlayerState }) => videoPlayerState;
export const getCurrentTime = ({ videoPlayerState }) => videoPlayerState.currentTime;
export const getPLAYER = ({ videoPlayerState }) => videoPlayerState.PLAYER;
export const getVolume = ({ videoPlayerState }) => videoPlayerState.volume;
export const getRealDuration = ({ videoPlayerState }) => videoPlayerState.realDuration;
export const getIsPlaying = ({ videoPlayerState, viewMode }) => videoPlayerState.isPlaying && !videoPlayerState.waitingForAction
&& viewMode !== 'text';
export const getIsStarted = ({ videoPlayerState }) => videoPlayerState.isStarted;
export const getSubtitlesVisibility = ({ videoPlayerState }) => videoPlayerState.subtitlesVisibility;
export const getIsBellEnabled = ({ videoPlayerState }) => videoPlayerState.isBellEnabled;
export const getIsPlayerReady = ({ videoPlayerState }) => videoPlayerState.isReady;
export const getIsBellHintVisibility = ({ videoPlayerState }) => videoPlayerState.bellHintVisibility;
export const getIsFullscreen = ({ videoPlayerState }) => videoPlayerState.isFullscreen;
export const getAutoPlay = ({ videoPlayerState }) => videoPlayerState.autoplay;


export const getBookState = ({ book }) => book;
const isIframeHorizontal = () => {
  const {
    document: {
      documentElement: {
        offsetWidth,
        offsetHeight,
      }
    }
  } = window
  return offsetWidth / offsetHeight > 1;
};
export const getBookSubtitles = createSelector(getBookState, book => book.sub ? book.sub.download_link : '');
export const getEncriptedImages = createSelector(getBookState, book => book.encriptedImages);
export const getAudioHLSUrl = createSelector(getBookState, book => book.audio_hls || '');
export const getVideoHLSUrl = createSelector(getBookState, book => book.video_hls || '');
export const getAudioBookStream = createSelector(getBookState, book => {
  return book.audio_music_stream
    ? book.audio_music_stream.audio_stream_url
    : ''
});
export const getBookInfo = createSelector(getBookState, book => book.bookInfo);
export const getLinkToBook = createSelector(getBookInfo, bookInfo => bookInfo.link_to_web);
export const getFullDuration = createSelector(getBookInfo, bookInfo => bookInfo.length);
export const getBookType = createSelector(getBookInfo, bookInfo => bookInfo.type);
export const getBookId = createSelector(getBookInfo, bookInfo => bookInfo.bookId);
export const getIsOwner = createSelector(getBookInfo, bookInfo => bookInfo.isOwner);
export const getTotalNumberOfFrames = createSelector(getBookInfo, bookInfo => bookInfo.frames);
export const getIsBookFetched = createSelector(getBookInfo, bookInfo => bookInfo && Object.keys(bookInfo).length > 0);
export const getBookTitle = createSelector(getBookInfo, bookInfo => bookInfo.title);
export const getAvailableResolutions = createSelector(getBookInfo, bookInfo => bookInfo.resolution);

export const getIsDemo = createSelector(getBookState, book => book.isDemo);
export const getIsFree = createSelector(getBookState, book => book.isFree);
export const getImageSlides = createSelector(getBookState, book => book.jpg);
export const getSlideThumbnails = createSelector(getBookState, book => book.small);
export const getBookFramesTime = createSelector(getBookState, book => book.framesTime);
export const getIsBookWithText = createSelector(getBookState, book => !!book.hasText);
export const getBookTexts = createSelector(getBookState, book => book.text);
export const getIsBookFetching = createSelector(getBookState, book => book.loading);
export const getBookCover = createSelector([
  isIframeHorizontal,
  getBookState
],
  (isHorizontal, bookState) => isHorizontal
    ? bookState.cover_h.download_link || bookState.cover_v.download_link
    : bookState.cover_v.download_link || bookState.cover_h.download_link
)


export const getControlsState = ({ controlsState }) => controlsState;
export const getControlsVisibility = createSelector(getControlsState, controlsState => controlsState.isVisible);
export const getIsControlsOnHover = createSelector(getControlsState, controlsState => controlsState.isControlsHover);
export const getIdOfHiddingTimer = createSelector(getControlsState, controlsState => controlsState.timerId);





export const getTextReaderState = ({ textReader }) => textReader;
export const getIsSlideZoomed = createSelector(getTextReaderState, textReaderState => textReaderState.isSlideZoomed);
export const getCurrentTheme = createSelector(getTextReaderState, textReaderState => textReaderState.theme);
export const getCurrentTextAreaPage = createSelector(getTextReaderState, textReaderState => textReaderState.textAreaPage);
export const getTextHeight = createSelector(getTextReaderState, textReaderState => textReaderState.textHeight);

export const getLoginPopupVisibility = ({ loginPopup }) => loginPopup.isVisible;



export const getIsWidget = ({ app }) => app.isWidget;
export const getParentSelector = ({ app }) => app.parentSelector;
export const getIsWidgetChannel = ({ app }) => app.isWidgetChannel;
export const getIsWidgetBooks = ({ app }) => app.isWidgetBooks;
export const getIsAuthorized = ({ app }) => app.token !== null;
export const getApiKey = ({ app }) => app.apiKey;
export const getVideoResolution = ({ app }) => app.resolution;
export const getIsResolutionPopupOpened = ({ app }) => app.isResolutionPopupOpened;

export const getUnavailablePopupVisibility = ({ unavailablePopup }) => unavailablePopup.isShown;



export const getActiveFrame = ({ activeFrame }) => activeFrame;
export const getCurrentAudioChapterState = ({ crrentAudioChapter }) => crrentAudioChapter;
export const getGalleryVisibility = ({ galleryVisibility }) => galleryVisibility;
export const getViewMode = ({ viewMode }) => viewMode;
export const getTextSettingsVisibiility = ({ showTextSettings }) => showTextSettings;

export const getSecondsToNextTimeTrack = ({ tracking }) => tracking.secondsToNextTimeTrack;

export const getAudioBookChapters = createSelector(
  [ getBookState ],
  (book) => book.frame_stream_description || {}
);

export const getCurrentAudioChapter = createSelector(
  [
    getCurrentAudioChapterState,
    getAudioBookChapters
  ],
  (currentChapterNumber, audioChapters) => audioChapters[currentChapterNumber] || {}
);


export const getTextOfTheCurrentFrame = createSelector([
  getActiveFrame,
  getBookTexts
],
  (activeFrame, texts) => {
    return (texts[activeFrame] && texts[activeFrame].data) || '';
  }

);

export const getFrameCalculatedFromTime = createSelector(
  [
    getCurrentTime,
    getBookFramesTime
  ],
  (currentTime, framesTime) => {
    if (!Array.isArray(framesTime)) { // it happens if book === film // TODO change condition to something more obvious
      return 0;
    }

    return framesTime.reduce((frameNumber, item, frameIndex, array) => {
      const currentFrameTime = +item;

      // TODO На времени последнего фрейма не отдается его индекс убрать костыль currentFrameTime * currentFrameTime
      const nextFrameTime = +array[frameIndex + 1] || currentFrameTime * currentFrameTime;

      if (currentFrameTime <= currentTime && nextFrameTime >= currentTime) {
        frameNumber = frameIndex
      }
      return frameNumber;
    }, 0)
  }
);

export const getIsAudioBook = createSelector(
  [ getBookType ],
  (bookType) => [AUDIO, AUDIO_BOOK].includes(bookType)
);

export const getAvailableNumberOfFrames = createSelector(
  [getBookState, getIsAudioBook],
  (book, isAudio) => isAudio ? getFramesCount(book.framesTime) : getFramesCountTextMode(book.jpg)
);

const getFramesCountTextMode = (images) => images ? Object.keys(images).length - 1  : 0;
const getFramesCount = (framesTime) => framesTime ? framesTime.length - 1 : 0;

export const getTimeCalculatedFromFrameNumber = createSelector(
  [
    getBookFramesTime,
    getActiveFrame,
  ],
  (framesTime, activeFrame) => framesTime[activeFrame]
);

export const getIsNeedToTrack = createSelector(
  [
    getIsDemo,
    getIsFree,
    getIsOwner,
  ],
  (isDemo, isFree, isOwner) => !isDemo && !isFree && !isOwner
);



// WEBPACK FOOTER //
// ./src/store/selectors/selectors.js